import ActionCard from './ActionCard.vue';

export default {
  components: { ActionCard },
  data() {
    return {
      activeTab: 0,
      actionId: null,
      showDescID: null,
      dialog: {
        active: false,
        content: '',
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    actions() {
      return this.$store.state.sales.actions;
    },
    activeActions() {
      return this.actions.filter(a => a.is_actual);
    },
    completedActions() {
      return this.actions.filter(a => !a.is_actual);
    },
    tabConfigs() {
      return [
        {
          actions: this.activeActions,
          emptyMessage: 'На данный момент активных акций не найдено.',
          showParticipate: true,
          showParticipationInfo: false,
        },
        {
          actions: this.completedActions,
          emptyMessage: 'Завершённых акций не найдено.',
          showParticipate: false,
          showParticipationInfo: true,
        },
      ];
    },
  },
  methods: {
    async takePart(action) {
      if (this.actionId || action.is_confirmed) return;
      this.actionId = action.id;
      try {
        await this.$store.dispatch('sales/ConfirmAction', {
          profile_id: this.user.profile_id,
          action_id: action.id,
        });
      } finally {
        this.actionId = null;
      }
    },
    ShowDesc(id) {
      this.showDescID = this.showDescID === id ? null : id;
    },
    showPDF(url) {
      this.dialog.active = true;
      this.dialog.content = `<iframe src="${url}" style="width:100%; min-height:700px" frameborder="0"></iframe>`;
    },
  },
  mounted() {
    this.$store.dispatch('sales/ClearAction');
    this.$store.dispatch('sales/ClearSale');
    this.$store.dispatch('sales/GetActionsList', { profile_id: this.user.profile_id });
  },
};
